import { APP_TYPE_ENUM } from '@tenant/utility/constants/enum';

export default function (integrationMode) {
  return integrationMode?.toString() === APP_TYPE_ENUM['Modular'].toString();
}
